<p-dialog
  modal="true"
  styleClass="atlas-dialog-m"
  [closable]="false" [(visible)]="show"
>
  <ng-template pTemplate="header">
    <h4>{{ 'shared.container.toolbars.module.revenue.new-invoice-dialog.select-profile-header' | translate | titlecase }}</h4>
  </ng-template>
  <div class="dialog-body-container">
    <div>
      <wl-profile-quicksearch (searchComplete)="setResults($event)"></wl-profile-quicksearch>
    </div>
    <div *ngIf="profileResults">
      <wl-profile-results-grid [profiles]="profileResults" (onProfileSelected)="profileSelected($event)"></wl-profile-results-grid>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-default" (click)="show = false">{{ 'common.cancel' | translate | uppercase }}</button>
  </ng-template>
</p-dialog>
